import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Button ,
  Box
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const NotificationsTable = () => {
  const [notifications, setNotifications] = useState([]);
  
  useEffect(() => {
    axios.get('https://admin.bizstor.lk/public/api/notifications')
      .then(response => {
        setNotifications(response.data);
      })
      .catch(error => {
        console.error("There was an error fetching the notifications:", error);
      });
  }, []);

  const handleDelete = (id) => {
    axios.delete(`https://admin.bizstor.lk/public/api/notifications/${id}`)
      .then(response => {
        setNotifications(notifications.filter(notification => notification.id !== id));
      })
      .catch(error => {
        console.error("There was an error deleting the notification:", error);
      });
  };

  const handleEdit = (notification) => {
    alert(`Editing notification: ${notification.title}`);
  };

  return (
    <Box
    sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '95%',
                    maxWidth: 'auto',
                    margin: 'auto',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative',
                    '@media (max-width: 600px)': {
                        marginTop: '10px',
                    },
                }}
    >
    <TableContainer component={Box}>
      <Table sx={{ minWidth: 650 }} aria-label="notifications table">
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Message</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Actions</TableCell> {/* Add an Actions column */}
          </TableRow>
        </TableHead>
        <TableBody>
          {notifications.map((notification) => (
            <TableRow key={notification.id}>
              <TableCell component="th" scope="row">
                {notification.title}
              </TableCell>
              <TableCell>{notification.message}</TableCell>
              <TableCell>{new Date(notification.created_at).toLocaleDateString()}</TableCell> {/* Show only date */}
              <TableCell>
                {/* Only show icons without text */}
                <Button onClick={() => handleEdit(notification)} color="primary" variant="outlined" size="small" startIcon={<EditIcon />} />
                <Button onClick={() => handleDelete(notification.id)} color="secondary" variant="outlined" size="small" startIcon={<DeleteIcon />} style={{ marginLeft: '8px' }} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Box>
  );
};

export default NotificationsTable;
